"use client";

import { useEffect, useState } from "react";

import { Button, Modal, Table } from "react-bootstrap";

import OverviewModal from "./overview-modal/overview-modal";

type SurveyOverviewProps = {
  study: { id: number; title: string; full_name: string; has_overview: boolean };
  countries: string;
  year_started: number;
};
export default function OverviewTable({
  overviews,
  study_name,
  cohort_name,
}: {
  overviews: SurveyOverviewProps[];
  study_name: string | undefined;
  cohort_name: string | undefined;
}) {
  const [showModal, setShowModal] = useState(false);
  const [studyId, setStudyId] = useState<number>();
  const [studyTitle, setStudyTitle] = useState<string>();

  const handleStudyClick = (studyId: number, studyTitle: string) => {
    setStudyId(studyId);
    setStudyTitle(studyTitle);
    setShowModal(true);
  };

  useEffect(() => {
    if (!study_name) return;
    const matchedStudy = overviews.find((row) => row.study.title === study_name && row.study.has_overview);
    if (matchedStudy) {
      handleStudyClick(matchedStudy.study.id, matchedStudy.study.title);
    }
  }, [study_name, overviews]);

  return (
    <>
      <Table striped responsive>
        <thead>
          <tr className="g2-table-header-blue">
            <th>Studies</th>
            <th>Full Name</th>
            <th>Countries</th>
            <th>Year Started</th>
          </tr>
        </thead>
        <tbody>
          {overviews.map((row) => (
            <tr key={row.study.id} className="align-middle">
              {row.study.has_overview ? (
                <td className="g2-link-blue fw-bold" onClick={() => handleStudyClick(row.study.id, row.study.title)}>
                  {row.study.title}
                </td>
              ) : (
                <td className="fw-bold">{row.study.title}</td>
              )}
              <td>{row.study.full_name}</td>
              <td>{row.countries}</td>
              <td>{row.year_started}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Modal show={showModal} onHide={() => setShowModal(false)} size="xl" aria-labelledby="srv-overview-modal">
        <Modal.Header closeButton>
          <Modal.Title className="g2-text-grey">{studyTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {studyId !== undefined && <OverviewModal studyId={studyId} cohort_name={cohort_name} />}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
